import { maybeLoadGmaps } from '../../../../../../../plugins/oncarrot-map/maybe-load-gmaps.js';

export function setupAutocomplete() {
  const addresses = jQuery('.autocomplete-us');
  const addressData = {};

  if (!addresses.length) {
    return;
  }

  if (!window.onCarrot) {
    window.onCarrot = {};
  }

  addresses.each(function () {
    // Already processed — setup re-runs on gform_post_render
    if (jQuery(this).find('.autocomplete-address').length) {
      return;
    }

    // A field flagged by validation keeps its real inputs so the visitor can fix them
    if (jQuery(this).hasClass('gfield_error')) {
      return;
    }

    const address = {};
    const streetInputId = jQuery(this)
      .find('.address_line_1 > input')
      .attr('id');

    if (!streetInputId) {
      return;
    }

    // Street input id is unique per form instance, so duplicate forms can't collide
    const addressID = 'autocomplete-' + streetInputId;

    // Hide the default full address field set
    jQuery(this).find('.ginput_complex').hide();

    address.street_number = {
      id: streetInputId,
      value: 'short_name',
    };
    address.route = {
      id: jQuery(this).find('.address_line_2 > input').attr('id'),
      value: 'short_name',
    };
    address.locality = {
      id: jQuery(this).find('.address_city > input').attr('id'),
      value: 'long_name',
    };
    address.administrative_area_level_1 = {
      id: jQuery(this).find('.address_state > select').attr('id'),
      value: 'long_name',
    };
    address.postal_code = {
      id: jQuery(this).find('.address_zip > input').attr('id'),
      value: 'long_name',
    };

    addressData[addressID] = address;

    const placeholder = jQuery(this)
      .find('.address_line_1 input')
      .attr('placeholder');

    // Create the autocomplete field and its clear control
    const autocompleteInput = jQuery(
      "<input type='text' id='" +
        addressID +
        "' class='ginput_full autocomplete-address' placeholder='" +
        (placeholder ? placeholder : '') +
        "'>"
    );
    const clearButton = jQuery(
      "<button type='button' class='autocomplete-clear' aria-label='Clear address' title='Clear address' aria-controls='" +
        addressID +
        "'><svg aria-hidden='true' focusable='false' width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round'><path d='m6 6 12 12M18 6 6 18'/></svg></button>"
    );

    // The box sits outside every <label>, and a legend names only its fieldset, so
    // point it at the field label. GF renders the legend without an id; a hidden
    // label still names it. Fall back to the street sub-label we hide (#10200).
    const fieldLabel = jQuery(this).find('.gfield_label').first();
    if (fieldLabel.length && fieldLabel.text().trim()) {
      if (!fieldLabel.attr('id')) {
        fieldLabel.attr('id', addressID + '-label');
      }
      autocompleteInput.attr('aria-labelledby', fieldLabel.attr('id'));
    } else {
      autocompleteInput.attr(
        'aria-label',
        jQuery(this).find('.address_line_1 label').text().trim() ||
          'Street Address'
      );
    }

    // Insert it before the default full field set
    jQuery(this)
      .find('.gfield_label')
      .after(
        jQuery("<span class='autocomplete-box'></span>").append(
          autocompleteInput,
          clearButton
        )
      );

    // Re-render after another field's error: show the address that already posted (#9667).
    // The state select can carry a default with nothing else filled; that is not an address.
    const part = (id) => (jQuery('#' + id).val() || '').trim();
    const posted = [
      part(streetInputId),
      part(address.locality.id),
      part(address.postal_code.id),
    ];
    if (posted.some(Boolean)) {
      posted.splice(2, 0, part(address.administrative_area_level_1.id));
      autocompleteInput.val(posted.filter(Boolean).join(', '));
      autocompleteInput.data('picked', autocompleteInput.val().trim());
    }

    updateClearControl(addressID);
    clearButton.on('click', () => clearAddress(addressID));
    autocompleteInput.on('input', () => {
      if (!autocompleteInput.val().trim()) {
        clearAddressFields(addressID);
        autocompleteInput.removeData('picked');
      }
      updateClearControl(addressID);
    });

    function chromeForceDisableAutocomplete(el) {
      if (
        navigator.userAgent.indexOf('Chrome') !== -1 &&
        el.getAttribute('autocomplete') === 'off'
      ) {
        el.setAttribute('autocomplete', 'new-password');
      }
    }

    // Prevent pressing enter when selecting an address to submit the form
    jQuery('#' + addressID)
      .keydown(function (e) {
        chromeForceDisableAutocomplete(e.target);

        if (e.keyCode == 13) {
          e.preventDefault();
        }
      })
      .focus(function (e) {
        chromeForceDisableAutocomplete(e.target);
      });

    // Edited text posts as street; stale city, state, and ZIP must not accompany it.
    jQuery(this)
      .closest('form')
      .on('submit', function () {
        const typed = autocompleteInput.val().trim();
        if (!typed || typed === autocompleteInput.data('picked')) {
          return;
        }
        jQuery('#' + streetInputId).val(typed);
        [
          address.locality,
          address.administrative_area_level_1,
          address.postal_code,
        ].forEach((part) => jQuery('#' + part.id).val(''));
      });
  });

  // Merge (not replace) so instances set up in earlier runs keep working
  window.onCarrot.addresses = Object.assign(
    window.onCarrot.addresses || {},
    addressData
  );
}

// Keep the import static — a dynamic one makes vite emit __vitePreload as a
// separate chunk. Google's script is still lazy; maybeLoadGmaps() is gated on
// the form's first interaction.
export const loadGmaps = async () => {
  await maybeLoadGmaps({ jQuery })
    .then(initAutocomplete)
    .catch(function (e) {
      console.log('error loading gmaps in carrot gf address autocomplete');
      throw e;
    });
};

/**
 * Google Places Autocomplete functions
 */
const autocompleteAddresses = {};

export function initAutocomplete() {
  // Create the autocomplete object, restricting the search to geographical
  // location types.
  if (window.onCarrot && window.onCarrot.addresses) {
    const addresses = window.onCarrot.addresses;
    Object.keys(addresses).forEach(function (addressID) {
      const input = document.getElementById(addressID);

      // Skip fields that were destroyed by a re-render or already bound
      if (!input || input.dataset.gmapsBound) {
        return;
      }
      input.dataset.gmapsBound = '1';

      const autocomplete = new google.maps.places.Autocomplete(input, {
        types: ['geocode'],
      });

      // When the user selects an address from the dropdown, populate the address
      // fields in the form.
      addAutoCompleteListener(autocomplete, addressID);

      autocompleteAddresses[addressID] = autocomplete;
    });
  }
}

export function addAutoCompleteListener(autocomplete, addressID) {
  autocomplete.addListener('place_changed', function () {
    const place = autocomplete.getPlace();
    fillInAddress(addressID, place);
  });
}

export function fillInAddress(addressID, place) {
  // Get correct form to work with
  const box = jQuery('#' + addressID);
  const gform_body = box.closest('.gform_body');

  // Enter on free text fires place_changed with only a name; that is not a pick
  if (!place || !place.address_components || !place.address_components.length) {
    return;
  }

  // Whatever the last pick filled that this one does not supply must not survive (#9822)
  clearAddressFields(addressID);

  // Get each component of the address from the place details
  // and fill the corresponding field on the form.
  const target = window.onCarrot.addresses[addressID];
  const find = (type) =>
    place.address_components.find((c) => c.types.includes(type));

  Object.keys(target).forEach((addressType) => {
    const component =
      addressType === 'locality'
        ? CITY_TYPES.map(find).find(Boolean)
        : find(addressType);
    if (!component) {
      return;
    }
    const val = component[target[addressType].value];

    // Street name should be appended to address line 1
    if (addressType == 'route') {
      const streetNumber = gform_body.find('#' + target['street_number'].id);
      streetNumber.val((streetNumber.val() + ' ' + val).trim());
      streetNumber.trigger('change');
    } else {
      const field = gform_body.find('#' + target[addressType].id);
      field.val(val);
      field.trigger('change');
    }
  });

  box.data('picked', box.val().trim());
  updateClearControl(addressID);
}

// Empty the hidden sub-fields Places fills. The state select lands on its blank option.
function clearAddressFields(addressID) {
  const gform_body = jQuery('#' + addressID).closest('.gform_body');
  Object.values(window.onCarrot.addresses[addressID]).forEach((part) => {
    gform_body
      .find('#' + part.id)
      .val('')
      .trigger('change');
  });
}

function updateClearControl(addressID) {
  const box = jQuery('#' + addressID);
  // Match the input text, not a potentially white-on-dark surrounding section.
  box.siblings('.autocomplete-clear').css('color', box.css('color'));
  box
    .closest('.autocomplete-us')
    .toggleClass('has-address', !!box.val().trim());
}

export function clearAddress(addressID) {
  clearAddressFields(addressID);
  jQuery('#' + addressID)
    .val('')
    .removeData('picked');
  updateClearControl(addressID);
  jQuery('#' + addressID).trigger('focus');
}

// Google leaves out `locality` for unincorporated places and CDPs (#9819)
const CITY_TYPES = [
  'postal_town',
  'locality',
  'sublocality_level_1',
  'neighborhood',
  'administrative_area_level_3',
];

// Bias the autocomplete object to the user's geographical location,
// as supplied by the browser's 'navigator.geolocation' object.
export function geolocate(id) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(function (position) {
      const geolocation = {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      };
      const circle = new google.maps.Circle({
        center: geolocation,
        radius: position.coords.accuracy,
      });
      autocompleteAddresses[id].setBounds(circle.getBounds());
    });
  }
}
